module.exports = __webpack_public_path__ + "img/news.6dff308a.png";